import { render, staticRenderFns } from "./DarkRoom.vue?vue&type=template&id=844675dc&scoped=true&"
import script from "./DarkRoom.vue?vue&type=script&lang=js&"
export * from "./DarkRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844675dc",
  null
  
)

export default component.exports